// @unocss-include

export const useProviders = (currentProvider: string) => {
    const providers = ref([
        {
            label: 'Feide',
            name: 'oidc',
            active: true,
            disabled: Boolean(currentProvider === 'oidc'),
            icon: 'i-simple-icons-openid'
        }
    ]);
    return {
        providers
    };
};
